import { Card, H5 } from '@blueprintjs/core';
import AppContentView from 'Components/Generic/AppContentView';
import styles from './Configuration.module.css';
import YearConfig from './YearConfig';

const Configuration = () => {
  return (
    <AppContentView title='Session Configuration' hideBreadcrumbs>
      <Card className={styles.options_card}>
        <H5>Data Filters</H5>
        <YearConfig />
      </Card>
    </AppContentView>
  );
};
export default Configuration;
